'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _index = require('../../reducers/index.js');

var _index2 = _interopRequireDefault(_index);

var _galleryActions = require('../../actions/galleryActions.js');

var _galleryContainer = require('./galleryContainer.js');

var _galleryContainer2 = _interopRequireDefault(_galleryContainer);

var _galleryContainerNew = require('./galleryContainerNew.js');

var _galleryContainerNew2 = _interopRequireDefault(_galleryContainerNew);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _WixSdkWrapper = require('photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _videoActionTypes = require('../../constants/videoActionTypes');

var _videoActionTypes2 = _interopRequireDefault(_videoActionTypes);

var _videoMiddleware = require('../item/videos/videoMiddleware');

var _videoMiddleware2 = _interopRequireDefault(_videoMiddleware);

var _videoQueue = require('../item/videos/video-queue');

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProGallery = function (_React$Component) {
  (0, _inherits3.default)(ProGallery, _React$Component);

  function ProGallery(props) {
    (0, _classCallCheck3.default)(this, ProGallery);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProGallery.__proto__ || (0, _getPrototypeOf2.default)(ProGallery)).call(this));

    if (_utils2.default.isVerbose()) {
      console.count('[OOISSR] proGallery constructor', _windowWrapper2.default.isMock);
    }
    var isSSR = !!_windowWrapper2.default.isMock;
    _this.canRender = !isSSR || props.allowSSR === true; //do not render if it is SSR
    if (_this.canRender) {
      _this.init(props);
    }
    return _this;
  }

  (0, _createClass3.default)(ProGallery, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.store && this.store.dispatch && this.props.forceHover === true) {
        this.store.dispatch((0, _galleryActions.toggleHoverPreview)(this.props.forceHover));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.store && this.store.dispatch && nextProps.forceHover !== this.props.forceHover) {
        this.store.dispatch((0, _galleryActions.toggleHoverPreview)(nextProps.forceHover));
      }
    }
  }, {
    key: 'init',
    value: function init(props) {
      this.domId = props.domId || Math.floor(Math.random() * 10000);
      if (_utils2.default.isVerbose()) {
        console.log('[OOISSR] proGallery init', _windowWrapper2.default.isMock);
      }
      var middlewares = [_reduxThunk2.default, (0, _videoMiddleware2.default)({ videoQueue: new _videoQueue.VideoQueue(), utils: _utils2.default })];
      this.store = (0, _redux.createStore)(_index2.default, /* { gallery: { videoPlayMode: videoPlayModes.hover } } */{}, _redux.applyMiddleware.apply(undefined, middlewares));
      this.initStoreEvents(this.store);
    }
  }, {
    key: 'initStoreEvents',
    value: function initStoreEvents(store) {
      if (_WixSdkWrapper2.default && _WixSdkWrapper2.default.addEventListener) {
        _WixSdkWrapper2.default.addEventListener(_WixSdkWrapper2.default.Events.STYLE_PARAMS_CHANGE, function (styleParams) {
          store.dispatch({
            type: _videoActionTypes2.default.videoModeChanged,
            payload: styleParams.numbers.videoPlay
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var ProGalleryComponent = this.props.useRefactoredProGallery === true ? _galleryContainerNew2.default : _galleryContainer2.default;
      return this.canRender && _react2.default.createElement(
        'div',
        { id: 'pro-gallery-' + this.domId, className: 'pro-gallery' },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(ProGalleryComponent, (0, _extends3.default)({}, this.props, {
            domId: this.domId,
            items: this.props.items || require('../../constants/default-images.js').defaultImages,
            store: this.store,
            watermarkData: this.props.watermarkData,
            settings: this.props.settings || {},
            offsetTop: this.props.offsetTop
          }))
        )
      );
    }
  }]);
  return ProGallery;
}(_react2.default.Component);

exports.default = ProGallery;